import React, { useMemo } from 'react'
import DetailsLoader from './Forms/DetailsLoader'
import useManageReturnType from './hooks/useManageReturnType'
import RMADetailModule from './rmaDetailModule/RMADetailModule'
import { RMADetailLoaderContainer } from './style/RMA.css'

const RMADetails = props => {
  const type = useManageReturnType(props)
  const data = useMemo(() => ({ ...props, type }), [props, type])
  const { orderDetails } = { ...data }
  if (!orderDetails || !orderDetails?.parts) {
    return (
      <>
        <RMADetailLoaderContainer>
          <DetailsLoader key="detailsLoader" loading />
        </RMADetailLoaderContainer>
      </>
    )
  }

  return (
    <RMADetailModule data={data} />
  )
}

export default RMADetails
